export default {
  form: {
    gtin: {
      label: 'GTIN',
    },
    pfand: {
      label: 'Depozit sticlă',
    },
    product_type: {
      label: 'Tip produs',
      options: {
        packaged: 'Ambalat',
        prepared: 'Preparat',
      },
    },
    packaging_material: {
      label: 'Material ambalaj',
    },
    brand_or_manufacturer: {
      label: 'Marcă sau producător',
    },
    net_quantity: {
      label: 'Cantitate netă',
    },
    base_price: {
      label: 'Setați prețul per unitate (ex. per litru pentru o băutură)',
      placeholder: 'Preț per unitate',
    },
    alcohol_by_volume_percent: {
      label: 'Procent alcool',
    },
    caffeine_mg_per_100ml: {
      label: 'Cafeină (mg per 100ml de produs)',
    },
    ingredients_text: {
      label: 'Ingrediente',
    },
    allergens_list: {
      label: 'Alergeni',
    },
    additives_list: {
      label: 'Aditivi',
    },
    has_nutrition_table: {
      label: 'Completați tabelul nutrițional (per 100{{unit}} de produs)',
    },
    energy_kj: {
      label: 'Energie (kJ)',
    },
    energy_kcal: {
      label: 'Energie (kcal)',
    },
    fat_g: {
      label: 'Grăsimi',
    },
    saturates_g: {
      label: 'Acizi grași saturați',
    },
    carbohydrate_g: {
      label: 'Glucide',
    },
    sugars_g: {
      label: 'Zaharuri',
    },
    protein_g: {
      label: 'Proteine',
    },
    salt_g: {
      label: 'Sare',
    },
    identifiers: {
      label: 'Identificatori',
    },
  },
};
